import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToCreateCompanySteps = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;

  const generalCreateCompanySteps: StepType[] = [
    {
      content: 'Go to the Contacts menu tab',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.MENU}"]`,
      position: 'right',
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 200);
          },
          false,
        );
      },
      disableActions: true,
      styles: {
        arrow: (base) => ({
          ...base,
          visibility: 'hidden',
        }),
      },
    },
    {
      content: 'Then select Companies to view the Companies page',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.COMPANY.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 200);
          },
          false,
        );
      },
      disableActions: false,
      styles: {
        popover: (base) => ({ ...base, marginLeft: 11 }),
      },
    },
    {
      content: 'On the Companies page, click on the Create Company button',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.COMPANY.FORM.CREATE_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(3), 200);
            // setIsOpen(false);
          },
          false,
        );
      },
      position: 'bottom',
    },
    {
      content: (props) => (
        <Content
          {...props}
          content={
            // eslint-disable-next-line max-len
            "Fill out the form with the company's information, such as company name, industry, and type."
          }
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.COMPANY.FORM.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="Modal__Header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.COMPANY.FORM.FORM}"]`,
      ],
      disableActions: false,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(4), 100);
          },
          false,
        );
      },
      position: 'right',
      padding: 22,
    },
    {
      content: 'Click Save and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.COMPANY.FORM.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
      styles: {
        popover: (base) => ({ ...base, top: -8 }),
      },
    },
  ];

  const showCreateCompanySteps = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(generalCreateCompanySteps);
      setIsOpen(true);
    }, 300);
  };

  return showCreateCompanySteps;
};

export default useGetHowToCreateCompanySteps;
